module.exports = __webpack_public_path__ + "static/media/team_about_banner_m.d6ba5556.png";